export enum ConfigActionType {
  CONFIG_EDITING,
  CONFIG_PATHNAME,
  CONFIG_RESET_MODAL,
  CONFIG_DEFAULT_DATE_FORMAT,
  CONFIG_FOCUSRESET_ON,
  CONFIG_FOCUSRESET_OFF,
  CONFIG_SET_IS_SCANNING,
  CONFIG_BACKUP_INPUT_VALUE
}

export type Modal = {
  is?: boolean;
  show?: boolean;
  title?: string;
  labelYes?: string;
  labelNo?: string;
  action?: () => void;
};

export enum DefaultDateFormat {
  default = "dd/MM/yyyy",
  english = "MM/dd/yyyy",
}

export type ConfigState = {
  modalEditing: Modal;
  pathname: string;
  dateFormat: DefaultDateFormat;
  resetFocus: boolean;
  isScanning: boolean;
  backupInputValueIfIsScanning: string | null;
};

export enum SearchType {
  manual = "manual",
  scan = "scan",
}

export interface IConfigAction<T> {
  type: keyof typeof ConfigActionType;
  payload?: T;
}
